export default class ControllerBringSymbolsToFront {
  constructor(container) {
    this.container = container

    this.symbolsInFront = [];
  }

  bringToFront(symbol) {
    if (symbol.parentLayer === this.container) return;

    this.symbolsInFront.push(symbol);
    symbol.parentLayer = this.container;
  }

  bringAllBack() {
    this.symbolsInFront.forEach(symbol => {
      symbol.parentLayer = null;
    })

    this.symbolsInFront = [];
  }
}
